import { WppTypography } from '@wppopen/components-library-react'
import { Components as WppComponentTypes } from '@wppopen/components-library/dist/types/components'
import { TypographySkeleton } from 'components/Skeletons'

interface AsyncTypographyProps extends WppComponentTypes.WppTypography {
  isLoading?: boolean
  width?: number
  height?: number
  children?: string | string[] | React.ReactNode
  className?: string
  slot?: string
  dataTestId?: string
}

const AsyncTypography = ({
  isLoading,
  tag,
  type,
  children,
  className,
  width,
  height,
  slot = '',
  dataTestId,
}: AsyncTypographyProps) => {
  return isLoading ? (
    <TypographySkeleton type={type} className={className} width={width} height={height} slot={slot} />
  ) : (
    <WppTypography tag={tag} type={type} className={className} slot={slot} data-testid={dataTestId}>
      {children || null}
    </WppTypography>
  )
}

export default AsyncTypography
